<template>

    <div class="page-header">
      <h2>中信中证权持仓查询</h2>
      <div class="header-actions">
        <el-button type="primary" @click="zzzqOptionPosition" :loading="loading" icon="el-icon-refresh">
          查询期权持仓
        </el-button>
        <!-- 新增清理缓存按钮 -->
        <el-button type="warning" @click="clearCache" :loading="clearCacheLoading" icon="el-icon-delete">
          清理缓存
        </el-button>
        <el-button @click="exportData" :disabled="optionPositionData.length === 0">
          导出数据
        </el-button>
      </div>
    </div>

    <div class="content-section">
      <!-- 查询统计信息 -->
      <div class="stats-info" v-if="optionPositionData.length > 0">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="stat-card">
              <div class="stat-label">总持仓数量</div>
              <div class="stat-value">{{ optionPositionData.length }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card">
              <div class="stat-label">看涨期权</div>
              <div class="stat-value">{{ callOptionsCount }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card">
              <div class="stat-label">看跌期权</div>
              <div class="stat-value">{{ putOptionsCount }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card">
              <div class="stat-label">总权利金</div>
              <div class="stat-value">{{ totalPremium }} 元</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 期权持仓表格 -->
      <div class="table-section">
        <el-table
          :data="optionPositionData"
          border
          stripe
          v-loading="loading"
          style="width: 100%; margin-top: 20px;color: #333;"
          :default-sort="{prop: 'MATURITY_DATE', order: 'ascending'}"
        >
          <el-table-column type="index" label="序号" width="60" align="center" ></el-table-column>
          <el-table-column prop="I_CODE" label="代码" width="100" align="center" sortable>

              <template #default="scope">
                <a :href="getStockInfoUrl(scope.row.I_CODE)" target="_blank" class="stock-link">
                  {{ scope.row.I_CODE }}
                </a>
              </template>
          </el-table-column>
          <el-table-column prop="I_NAME" label="名称" width="120" align="center" sortable>
              <template #default="scope">
                <a :href="getStockInfoUrl(scope.row.I_NAME)" target="_blank" class="stock-link">
                  {{ scope.row.I_NAME }}
                </a>
              </template>
          </el-table-column>
          <el-table-column prop="STRIKE_PRICE" label="期初价格" width="100" align="center">
            <template #default="scope">
              {{ formatNumber(scope.row.STRIKE_PRICE) }}
            </template>
          </el-table-column>
          <el-table-column prop="STRIKE_DATE" label="入场日期" width="120" align="center" sortable></el-table-column>
          <el-table-column prop="MATURITY_DATE" label="到期日期" width="120" align="center" sortable></el-table-column>
          <el-table-column prop="RT_AVA_COUNT" label="名义本金" width="100" align="center" sortable>
            <template #default="scope">
              {{ formatNumber(scope.row.RT_AVA_COUNT) }}
            </template>
          </el-table-column>
          <el-table-column prop="DIRECTION" label="方向" width="80" align="center">
            <template #default="scope">
              <el-tag :type="scope.row.DIRECTION === 'L' ? 'success' : 'danger'" size="small">
                {{ scope.row.DIRECTION === 'L' ? '买入' : '卖出' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="OPTION_SUB_TYPE" label="期权类型" width="100" align="center">
            <template #default="scope">
              <el-tag :type="scope.row.OPTION_SUB_TYPE === 'CALL' ? 'warning' : 'info'" size="small">
                {{ scope.row.OPTION_SUB_TYPE === 'CALL' ? '看涨' : '看跌' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="UPFRONT_PAYOFF" label="权利金" width="100" align="center">
            <template #default="scope">
              {{ formatNumber(scope.row.UPFRONT_PAYOFF) }}
            </template>
          </el-table-column>
          <el-table-column prop="OPERATION" label="操作" width="100" align="center"></el-table-column>
          <el-table-column prop="BOOK" label="账簿" width="120" align="center"></el-table-column>
          <el-table-column prop="CURRENCY" label="币种" width="80" align="center"></el-table-column>
          <el-table-column label="操作" width="120" align="center" fixed="right">
            <template #default="scope">
              <el-button type="link" size="small" @click="viewDetail(scope.row)">查看详情</el-button>
              <el-button type="link" size="small" @click="closePosition(scope.row)">平仓</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页控件 -->
      <div class="pagination-section" v-if="optionPositionData.length > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="optionPositionData.length"
        ></el-pagination>
      </div>
    </div>
    <!-- 详情对话框 -->
    <el-dialog title="期权持仓详情" v-model="detailDialogVisible" width="600px">
      <div v-if="currentDetail">
        <div ref="detailContent" class="detail-content">
          <el-descriptions :column="2" border>
            <el-descriptions-item label="代码">
              <a :href="getStockInfoUrl(currentDetail.I_NAME)" target="_blank" class="stock-link">
                {{ currentDetail.I_CODE }}
              </a>
            </el-descriptions-item>
            <el-descriptions-item label="名称">
              <a :href="getStockInfoUrl(currentDetail.I_NAME)" target="_blank" class="stock-link">
                {{ currentDetail.I_NAME }}
              </a>
            </el-descriptions-item>
            <el-descriptions-item label="期初价格">{{ formatNumber(currentDetail.STRIKE_PRICE) }}</el-descriptions-item>
            <el-descriptions-item label="入场日期">{{ currentDetail.STRIKE_DATE }}</el-descriptions-item>
            <el-descriptions-item label="到期日期">{{ currentDetail.MATURITY_DATE }}</el-descriptions-item>
            <el-descriptions-item label="名义本金">{{ formatNumber(currentDetail.RT_AVA_COUNT) }}</el-descriptions-item>
            <el-descriptions-item label="方向">
              <el-tag :type="currentDetail.DIRECTION === 'L' ? 'success' : 'danger'">
                {{ currentDetail.DIRECTION === 'L' ? '买入' : '卖出' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="期权类型">
              <el-tag :type="currentDetail.OPTION_SUB_TYPE === 'CALL' ? 'warning' : 'info'">
                {{ currentDetail.OPTION_SUB_TYPE === 'CALL' ? '看涨' : '看跌' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="权利金">{{ formatNumber(currentDetail.UPFRONT_PAYOFF) }}</el-descriptions-item>
            <el-descriptions-item label="操作">{{ currentDetail.OPERATION }}</el-descriptions-item>
            <el-descriptions-item label="账簿">{{ currentDetail.BOOK }}</el-descriptions-item>
            <el-descriptions-item label="币种">{{ currentDetail.CURRENCY }}</el-descriptions-item>
            <el-descriptions-item label="交易ID">{{ currentDetail.TRADE_ID }}</el-descriptions-item>
            <el-descriptions-item label="当前日期">{{ currentDetail.BEGIN_DATE }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="copyDetailToClipboard" :loading="copyLoading" type="primary">
            <el-icon><DocumentCopy /></el-icon>
            复制表格
          </el-button>
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>


</template>

<script>
import axios from 'axios';
import { DocumentCopy } from '@element-plus/icons-vue';
import { copyTableToImage } from '@/utils/utils';

export default {
  name: 'GetZXZZ',
  components: {
    DocumentCopy
  },
  data() {
    return {
      loading: false,
      copyLoading: false,
      optionPositionData: [],
      currentPage: 1,
      pageSize: 10,
      detailDialogVisible: false,
      currentDetail: null,
      clearCacheLoading: false,
      cacheInfo: {
          hasCache: false,
          cacheTime: null,
          remainingTime: 0
      }
    };
  },
  computed: {
    // 计算看涨期权数量
    callOptionsCount() {
      return this.optionPositionData.filter(item => item.OPTION_SUB_TYPE === 'CALL').length;
    },
    // 计算看跌期权数量
    putOptionsCount() {
      return this.optionPositionData.filter(item => item.OPTION_SUB_TYPE === 'PUT').length;
    },
    // 计算总权利金
    totalPremium() {
      const total = this.optionPositionData.reduce((sum, item) => {
        const premium = parseFloat(item.UPFRONT_PAYOFF) || 0;
        return sum + premium;
      }, 0);
      return this.formatNumber(total);
    }
  },
  methods: {
   // 清理缓存
  async clearCache() {
    try {
      this.clearCacheLoading = true;
      const response = await axios.post('/api/clear_option_position_cache');
      if (response.data.status === 'success') {
        this.$message.success('缓存清理成功');
        this.cacheInfo.hasCache = false;
        this.cacheInfo.cacheTime = null;
        this.cacheInfo.remainingTime = 0;
      }
    } catch (error) {
      console.error('清理缓存失败:', error);
      this.$message.error('清理缓存失败');
    } finally {
      this.clearCacheLoading = false;
    }
  },
  // 获取缓存信息
  async getCacheInfo() {
    try {
      const response = await axios.get('/api/cache_info');
      this.cacheInfo = response.data;
    } catch (error) {
      console.error('获取缓存信息失败:', error);
    }
  },


    // 复制详情表格到剪贴板
    async copyDetailToClipboard() {
      try {
        this.copyLoading = true;

        // 等待DOM更新完成
        await this.$nextTick();

        const element = this.$refs.detailContent;
        if (!element) {
          this.$message.error('未找到要复制的内容');
          return;
        }

        // 使用现有的copyTableToImage工具函数
        const success = await copyTableToImage(element, {
          fileName: `${this.currentDetail.I_CODE}_$(this.currentDetail.I_NAME)_${new Date().toLocaleDateString()}`,
          title: '期权持仓详情'
        });

        if (success) {
          this.$message.success('表格已复制到剪贴板');
        } else {
          this.$message.error('复制失败，请重试');
        }
      } catch (error) {
        console.error('复制失败:', error);
        this.$message.error('复制失败，请重试');
      } finally {
        this.copyLoading = false;
      }
    },

    // 备用复制方案
    fallbackCopyImage(canvas) {
      // 创建临时链接下载图片
      const dataURL = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.download = `期权持仓详情_${this.currentDetail.I_CODE}_${new Date().toLocaleDateString()}.png`;
      link.href = dataURL;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.$message.success('图片已生成，请手动保存');
    },
    getStockDetailUrl(stockCode) {
      return `/stock-detail?stock_code=${stockCode}`;
    },

    // 获取股票信息查询链接
    getStockInfoUrl(stockName) {
      return `https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${encodeURIComponent(stockName)}`;
    },
    // 中信中证权持仓查询方法
     // 修改原有的查询方法，查询后更新缓存信息
  async zzzqOptionPosition() {
    try {
      this.loading = true;
      const response = await axios.get('/api/zzzq_option_position');
      this.optionPositionData = response.data.RESULTSET || [];
      this.showOptionPosition = true;

      // 查询后获取缓存信息
      await this.getCacheInfo();

      this.$message.success('查询成功');
    } catch (error) {
      console.error('查询失败:', error);
      this.$message.error('查询失败');
    } finally {
      this.loading = false;
    }
  },


    // 查看详情
    viewDetail(row) {
      this.currentDetail = row;
      this.detailDialogVisible = true;
    },

    // 平仓操作
    closePosition(row) {
      this.$confirm(`确定要平仓 ${row.I_NAME} 的期权持仓吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('平仓操作已提交');
        // 这里可以添加实际的平仓API调用
      }).catch(() => {
        this.$message.info('已取消平仓操作');
      });
    },

    // 导出数据
    exportData() {
      const headers = ['代码', '名称', '期初价格', '入场日期', '到期日期', '可用数量', '方向', '期权类型', '权利金', '操作', '账簿', '币种'];
      const data = this.optionPositionData.map(item => [
        item.I_CODE,
        item.I_NAME,
        item.STRIKE_PRICE,
        item.STRIKE_DATE,
        item.MATURITY_DATE,
        item.RT_AVA_COUNT,
        item.DIRECTION === 'L' ? '买入' : '卖出',
        item.OPTION_SUB_TYPE === 'CALL' ? '看涨' : '看跌',
        item.UPFRONT_PAYOFF,
        item.OPERATION,
        item.BOOK,
        item.CURRENCY
      ]);

      // 创建CSV内容
      let csvContent = headers.join(',') + '\n';
      data.forEach(row => {
        csvContent += row.join(',') + '\n';
      });

      // 创建下载链接
      const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `中信中证权持仓_${new Date().toLocaleDateString()}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.$message.success('数据导出成功');
    },

    // 格式化数字
    formatNumber(value) {
      if (value === null || value === undefined) return '-';
      const num = parseFloat(value);
      return isNaN(num) ? value : num.toLocaleString();
    },

    // 分页处理
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },

    handleCurrentChange(val) {
      this.currentPage = val;
    }
  },
  mounted() {
    // 页面加载时自动查询
     this.getCacheInfo();
  }
};
</script>

<style scoped>
.zzzq-option-page {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.stats-info {
  margin-bottom: 20px;
}

.stat-card {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 15px;
  text-align: center;
}

.stat-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 5px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #409eff;
}

.table-section {
  margin-top: 20px;
}

.pagination-section {
  margin-top: 20px;
  text-align: center;
}

.content-section {
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}


.stock-link {
  color: #409eff;
  text-decoration: none;
  transition: color 0.3s;
}

.stock-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}

.detail-content {
  background: white;
  padding: 10px;
  border-radius: 4px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

</style>
